import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import {
  TicketParseStrategy,
  TicketProcessingResponseDto,
} from '@features/client/models/ticket-processing-model';

@Injectable({ providedIn: 'root' })
export class TicketProcessingApiService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/public/bill-splits/ticket-processing`;

  processTicket(
    splitId: string,
    ticketImage: File | Blob,
  ): Observable<TicketProcessingResponseDto> {
    const formData = new FormData();
    formData.append('ticketImage', ticketImage, 'ticket.jpg');
    formData.append('splitId', splitId);

    return this.http.post<TicketProcessingResponseDto>(`${this.baseUrl}/process`, formData);
  }

  reprocessTicket(
    processingId: string,
    strategy?: TicketParseStrategy,
  ): Observable<TicketProcessingResponseDto> {
    let params = new HttpParams();

    if (strategy) {
      params = params.set('strategy', strategy);
    }

    return this.http.post<TicketProcessingResponseDto>(
      `${this.baseUrl}/${processingId}/reprocess`,
      null,
      { params },
    );
  }

  getProcessing(processingId: string): Observable<TicketProcessingResponseDto> {
    return this.http.get<TicketProcessingResponseDto>(`${this.baseUrl}/${processingId}`);
  }
}
